module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/nervousness/675e384ad5b79a59e45eeeefced7de16.png";